export const randomChartData={
  'status': 200,
  'data': [],
};
